module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp1-05-75185a431d0977744f2d7f2e1706ea40.png";